import * as css from './style.css';
import Btn from '../../../component/button/btn/Btn';
import {STATIC_IMAGE, TICK_DOMAIN} from '../../../config/config';
import {useTranslation} from 'react-i18next';
import Card from './card/card';
import {OrderData} from '../suspendedConfirmation';

const WontComeSuccess = ({orderData}: {orderData: OrderData}) => {
    const {t} = useTranslation('suspendedConfirmation');
    return (
        <Card subTitle={t('eventCanceled', {nameFirst: orderData.nameFirst})} mainTitle={orderData.eventTitle} {...orderData}>
            <css.confirmationBoxFlexCenter>
                <css.rightBox>   
                    <css.titleStart>
                        {t('notEasy')}
                    </css.titleStart>
                    <css.boldText>
                        {t('explanation')}
                    </css.boldText>
                </css.rightBox>
                <css.image 
                    src={`${STATIC_IMAGE}/app/ArrivalConfirmation/cancel.png`}
                    alt="" 
                />
            </css.confirmationBoxFlexCenter>
                
            <css.buttonRow>
                <Btn href={TICK_DOMAIN} onClick={() => {}}>
                    {t('finish')}
                </Btn>
            </css.buttonRow>    
        </Card>
    );
};

export default WontComeSuccess;